import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=7606cfe0&scoped=true&"
import script from "./UserNew.vue?vue&type=script&lang=js&"
export * from "./UserNew.vue?vue&type=script&lang=js&"
import style0 from "./UserNew.vue?vue&type=style&index=0&id=7606cfe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606cfe0",
  null
  
)

export default component.exports